import React, { useReducer, useState, useEffect } from "react"
import Drawer from "@kit/design/drawer"
import useFetch from "hooks/use-new-fetch"

import { Changelog } from "./changelog"
import Button from "./button"
import DrawerHeading from "./drawer-heading"
import { DiscoveryHubContext } from "./discovery-hub-context"

export function DiscoveryHub() {
  const discoveryHubState = {
    notificationCounter: 0
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case "setNotificationCounter":
        return {
          ...state,
          notificationCounter: action.count
        }
      case "decrementNotificationCounter":
        return {
          ...state,
          notificationCounter: state.notificationCounter - 1
        }
      case "setNotificationCounterToZero":
        return {
          ...state,
          notificationCounter: 0
        }
    }
  }

  const [state, dispatch] = useReducer(reducer, discoveryHubState)
  const [drawerActive, setDrawerActive] = useState(false)
  const toggleDrawer = () => setDrawerActive(!drawerActive)
  const [request] = useFetch("/onboarding/changelog_items/notification_count")

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await request.get({ path: "/" })
        dispatch({ type: "setNotificationCounter", count: response.data })
      } catch {
        // This probably indicates a network failure, safe to ignore
      }
    }

    fetchData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const hubContext = {
    notificationCounter: state.notificationCounter,
    decrementNotificationCounter: () => {
      dispatch({ type: "decrementNotificationCounter" })
    },
    setNotificationCounterToZero: () => {
      dispatch({ type: "setNotificationCounterToZero" })
    }
  }

  return (
    <DiscoveryHubContext.Provider value={hubContext}>
      <div>
        <Button is="secondary" toggleDrawer={toggleDrawer} />
      </div>

      {drawerActive && (
        <Drawer heading={<DrawerHeading />} onClose={toggleDrawer}>
          <Changelog />
        </Drawer>
      )}
    </DiscoveryHubContext.Provider>
  )
}

export { DiscoveryHubContext }
